import * as React from 'react';

const CreditCardFrontFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="credit-card-front-fill_svg__24_small_credit_card_front_fill-a"
                d="M0 14h20V0H0v14zm3-7V5h2l.008 2H3zm14 4h-2v-1h2v1zm-4 0h-2v-1h2v1zm-4 0H7v-1h2v1zm-4 0H3v-1h2v1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 5)">
            <mask
                id="credit-card-front-fill_svg__24_small_credit_card_front_fill-b"
                fill="#fff"
            >
                <use xlinkHref="#credit-card-front-fill_svg__24_small_credit_card_front_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#credit-card-front-fill_svg__24_small_credit_card_front_fill-a"
            />
            <g mask="url(#credit-card-front-fill_svg__24_small_credit_card_front_fill-b)">
                <path fill="#000" d="M-2-5h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CreditCardFrontFillSvg.displayName = 'CreditCardFrontFillSvg';
export default CreditCardFrontFillSvg;
